import React, { Fragment } from "react";
import useForm from "react-hook-form";
import { connect } from "react-redux";
import store from "store";
import ImageUpload from "./imageUpload";
import moment from "moment";
import { DatePicker, Card } from "antd";
const RowInput = ({
  onChangeItem,
  onChangeQuantity,
  onChangeRate,
  infoItem,
  mouseOver,
  mouseOut,
  onClose,
  index,
}) => {
  return (
    <div
      onMouseEnter={() => mouseOver(index)}
      onMouseLeave={() => mouseOut(index)}
      style={{ width: "104%", display: "flex", cursor: "pointer" }}
    >
      <div
        className="row p-r-15 p-l-15 m-t-10 m-b-10"
        style={{ width: "100%" }}
      >
        <div className="col-md-6 mb-12 p-r-0  ">
          <div className="p-t-5  p-b-5">
            <input
              className="form-control"
              // name="paymentTerms"
              type="text"
              onChange={(e) => onChangeItem(e.target.value, index)}
              placeholder="Description of service or product..."
              defaultValue={infoItem.item || ""}
            />
          </div>
        </div>
        <div className="col-md-2 mb-12 p-r-0  ">
          <div className="p-t-5  p-b-5" style={{ textAlign: "right" }}>
            <div class="input-group ">
              <div class="input-group-prepend">
                <span
                  class="input-group-text"
                  id="inputGroupPrepend2"
                  style={{ background: "#ffffff" }}
                >
                  QR
                </span>
              </div>
              <input
                className="form-control"
                onChange={(e) => onChangeRate(e.target.value, index)}
                type="number"
                defaultValue={infoItem.rate || 0}
                // style={{ textAlign: "right" }}
              />
            </div>

            {/* <input
              className="form-control"
              onChange={(e) => onChangeRate(e.target.value, index)}
              type="number"
              defaultValue={infoItem.rate || 0}
              style={{ textAlign: "right" }}
            /> */}
          </div>
        </div>

        <div className="col-md-2 mb-12 p-r-0  ">
          <div className="p-t-5  p-b-5">
            <input
              className="form-control"
              onChange={(e) => onChangeQuantity(e.target.value, index)}
              type="number"
              defaultValue={infoItem.quantity || 1}
              style={{ textAlign: "right" }}
            />
          </div>
        </div>
        <div className="col-md-2 mb-12 p-r-15  ">
          <div
            className=" p-b-5 "
            style={{ textAlign: "right", paddingTop: 5 }}
          >
            <input
              className="form-control"
              name="amount"
              type="text"
              value={"QR " + infoItem.amount || ""}
              placeholder=" "
              // ref={register({ required: true })}
              readOnly
              style={{
                fontWeight: 600,
                textAlign: "right",
                border: "unset",
                boxShadow: "unset",
                background: "#fff",
              }}
            />
            {/* <label for="validationCustom01" class="p-l-15 p-r-15 p-t-5">
              QR{infoItem.amount || ""} 
            </label> */}
          </div>
        </div>
      </div>
      <div className=" p-b-15" style={{ width: 40, paddingTop: 20 }}>
        {infoItem.isClose && (
          <i
            className="icofont icofont-close-circled custom-close-btn"
            style={{
              fontSize: 26,
            }}
            onClick={() => onClose(index)}
          ></i>
        )}
      </div>
    </div>
  );
};

const ProductForm = (props) => {
  const { register, handleSubmit, errors } = useForm(); // initialise the hook
  var {
    info,
    onChangeUrl,
    searchProductUrl,
    searchUrlStatus,
    isEdit,
    imageUrl,
    onChangeImage,
    removeImage,
    itemInfoProps,
    addLineItem,
    infoInvoiceItems,
    subtotal,
    onChangeAmountPaid,
    onChangeDiscount,
    onChangeShipping,
    onChangeTax,
    onChangeBill,
    onChangeDueBill,
  } = props;
  console.log({ info });
  const onSubmit = (data) => {
    console.log({ data });
    if (data !== "") {
      // onSubmitForm()/
      props.onClickConfirm(data);
    } else {
      errors.showMessages();
    }
  };
  const onChangeBillDate = (date, dateString) => {
    console.log({
      date,
      dateString,
    });
    // info.billDate = moment(dateString).format("MMM DD, YYYY");
    // this.setState({ info });
    //  var startDate = moment(dateString[0]).format();
    //  var endDate = moment(dateString[1]).format();
    onChangeBill(moment(dateString).format("MMM DD, YYYY"));
  };
  const onChangeDueBillDate = (date, dateString) => {
    console.log({ date, dateString });
    var date1 = moment(dateString).format("MMM DD, YYYY");
    console.log({ date, date1 });
    // info.dueBillDate = moment(dateString).format("MMM DD, YYYY");
    // this.setState({ info });
    //  var endDate = moment(dateString[1]).format();
    onChangeDueBill(moment(dateString).format("MMM DD, YYYY"));
  };
  return (
    <Fragment>
      <div className="container-fluid">
        <div className="card-body">
          <div className="row">
            <div className="col-md-10 mb-12 p-0  ">
              <form
                id="product-form-invoice"
                className="needs-validation"
                noValidate=""
                onSubmit={handleSubmit(onSubmit)}
              >
                <div className="form-row">
                  <div className="col-md-5 mb-12 p-t-5  p-b-5  ">
                    {/* <label htmlFor="validationCustom01" className="p-l-15 p-r-15">
                  Cover Image
                  <span>*</span>
                </label> */}
                    <div className="row">
                      {/* <div className="col-md-2 mb-2 text-center"></div> */}
                      <div className="col-md-12 mb-12 text-center p-t-15">
                        <img
                          className="imagePreview"
                          src={require("../../../assets/images/ATS_Logo.png")}
                          alt="preview"
                          style={{ height: "unset" }}
                        />
                        {/* <ImageUpload
                          imageUrl={imageUrl}
                          onChangeImage={onChangeImage}
                          removeImage={removeImage}
                        /> */}
                      </div>
                    </div>
                  </div>

                  <div className="col-md-7 mb-12 p-t-5  p-b-5">
                    <div className=" p-b-5 m-t-20 m-b-20">
                      <div className=" p-l-15 p-r-15">
                        <input
                          className="form-control hide-border"
                          name="invoice"
                          type="text"
                          defaultValue={info.invoice || "Cash Invoice"}
                          placeholder="Cash Invoice"
                          ref={register({ required: true })}
                          style={{
                            textAlign: "right",
                            // border: "unset",
                            height: 62,
                            fontSize: 46,
                            // border: "1px solid #fff !important",
                            boxShadow: "unset",
                            background: "#fff",
                          }}
                          readOnly
                          // style={{
                          //   fontWeight: 600,
                          //   textAlign: "right",
                          //   border: "unset",
                          //   boxShadow: "unset",
                          //   background: "#fff",
                          // }}
                        />
                        <span>{errors.invoice && "Invoice is required"}</span>
                        <div className="valid-feedback">Looks good!</div>
                      </div>
                    </div>
                    <div className="p-t-5  p-b-5  m-t-20 m-b-20">
                      <div className="row">
                        <div className="col-md-7 mb-12 p-0  "></div>
                        <div className="col-md-5 mb-12 p-0  ">
                          <div className=" p-l-15 p-r-15">
                            <div class="input-group p-l-15 p-r-15">
                              <div class="input-group-prepend">
                                <span
                                  class="input-group-text"
                                  id="inputGroupPrepend2"
                                >
                                  #
                                </span>
                              </div>
                              <input
                                class="form-control text-right"
                                id="validationDefaultUsername"
                                type="text"
                                name="invoiceNumber"
                                value={info.invoiceNumber}
                                placeholder="Invoice No."
                                aria-describedby="inputGroupPrepend2"
                                ref={register({ required: true })}
                                style={{ background: "#fff" }}
                                readOnly
                              />
                              <span>
                                {errors.invoiceNumber &&
                                  "Invoice no. is required"}
                              </span>
                              <div className="valid-feedback">Looks good!</div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-md-7 mb-12 p-t-5  p-b-5">
                    <div className="p-t-5  p-b-5">
                      <div className=" p-l-15 p-r-15">
                        <textarea
                          className="form-control"
                          name="invoiceForm"
                          type="text"
                          row="6"
                          defaultValue={info.invoiceForm}
                          placeholder="Who is this invoice from? (required)"
                          ref={register({
                            required: true,
                          })}
                          style={{ height: "64px", resize: "none" }}
                        />
                        <span style={{ color: "#ff5370" }}>
                          {errors.invoiceForm && "Invoice form is required"}
                        </span>
                        <div className="valid-feedback">Looks good!</div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-md-6 mb-12 p-r-0  ">
                        <div className="p-t-5  p-b-5">
                          <div className=" p-l-15 p-r-15">
                            <input
                              className="form-control hide-border"
                              name="billToText"
                              type="text"
                              defaultValue={info.billToText || "Bill From"}
                              placeholder="Bill To"
                              onChange={(e) =>
                                onChangeUrl(null, e.target.value)
                              }
                              ref={register({ required: true })}
                              style={{
                                border: "unset",
                                boxShadow: "unset",
                                background: "#fff",
                              }}
                              readOnly
                            />
                            <span>
                              {errors.billToText && "Bill to is required"}
                            </span>
                            <div className="valid-feedback">Looks good!</div>
                          </div>
                        </div>

                        <div className="p-t-5  p-b-5">
                          <div className=" p-l-15 p-r-15">
                            <textarea
                              className="form-control"
                              name="billTo"
                              type="text"
                              row="6"
                              value="Arab Tech Store &#13;&#10;C Ring Road Doha, Qatar."
                              placeholder="Who is this invoice to? (required)"
                              ref={register({
                                required: true,
                              })}
                              readOnly
                              style={{
                                height: "64px",
                                resize: "none",
                                background: "#fff",
                              }}
                            />

                            <span style={{ color: "#ff5370" }}>
                              {errors.billTo && "Bill to is required"}
                            </span>
                            <div className="valid-feedback">Looks good!</div>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6 mb-12 p-l-0 ">
                        <div className="p-t-5  p-b-5">
                          <div className=" p-l-15 p-r-15">
                            <input
                              className="form-control hide-border"
                              name="shipToText"
                              type="text"
                              defaultValue={info.shipToText || "Ship To"}
                              placeholder="Ship To"
                              style={{
                                border: "unset",
                                boxShadow: "unset",
                                background: "#fff",
                              }}
                              readOnly
                              ref={register({ required: false })}
                            />
                          </div>
                        </div>

                        <div className="p-t-5  p-b-5">
                          <div className=" p-l-15 p-r-15">
                            <textarea
                              className="form-control"
                              name="shipTo"
                              type="text"
                              row="6"
                              // placeholder="(optional)"
                              placeholder="Who is this invoice to? (required)"
                              ref={register({
                                required: true,
                              })}
                              style={{ height: "64px", resize: "none" }}
                              // ref={register({ required: false })}
                            />
                            <span style={{ color: "#ff5370" }}>
                              {errors.shipTo && "Bill to is required"}
                            </span>
                            <div className="valid-feedback">Looks good!</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-md-5 mb-12 p-t-5  p-b-5">
                    <div className="row p-r-15 m-t-10 m-b-10">
                      <div className="col-md-6 mb-12 p-r-0  ">
                        <div className="p-t-5  p-b-5">
                          <input
                            className="form-control hide-border"
                            name="billDateText"
                            type="text"
                            defaultValue={info.billDateText || "Date"}
                            placeholder="Date"
                            ref={register({ required: true })}
                            style={{
                              textAlign: "right",
                              border: "unset",
                              boxShadow: "unset",
                              background: "#fff",
                            }}
                            readOnly
                          />
                          <span>
                            {errors.billDateText && "Date is required"}
                          </span>
                          <div className="valid-feedback">Looks good!</div>
                        </div>
                      </div>
                      <div className="col-md-6 mb-12 p-r-15  ">
                        <div className="p-t-5  p-b-5">
                          <DatePicker
                            key="billDate"
                            onChange={(date, dateString) =>
                              onChangeBill(dateString)
                            }
                            // defaultValue={info.billDate}
                            format={"MMM DD, YYYY"}
                          />
                          <input
                            className="form-control"
                            name="billDate"
                            type="text"
                            value={info.billDate || ""}
                            ref={register({ required: true })}
                            hidden
                          />
                          <span>{errors.billDate && "Date is required"}</span>
                          <div className="valid-feedback">Looks good!</div>
                        </div>
                      </div>
                    </div>
                    <div className="row p-r-15 m-t-10 m-b-10">
                      <div className="col-md-6 mb-12 p-r-0  ">
                        <div className="p-t-5  p-b-5">
                          <input
                            className="form-control hide-border"
                            name="paymentTermsText"
                            type="text"
                            defaultValue={
                              info.paymentTermsText || "Payment Terms"
                            }
                            placeholder="Payment Terms"
                            ref={register({ required: true })}
                            style={{
                              textAlign: "right",
                              border: "unset",
                              boxShadow: "unset",
                              background: "#fff",
                            }}
                            readOnly
                          />
                          <span>
                            {errors.paymentTermsText &&
                              "Payment Terms is required"}
                          </span>
                          <div className="valid-feedback">Looks good!</div>
                        </div>
                      </div>
                      <div className="col-md-6 mb-12 p-r-15  ">
                        <div className="p-t-5  p-b-5">
                          <select
                            className="form-control"
                            name="paymentTerms"
                            ref={register({ required: true })}
                          >
                            <option>Cash</option>
                            <option>Online</option>
                          </select>
                          {/* <input
                            className="form-control"
                            name="paymentTerms"
                            type="text"
                            defaultValue={info.paymentTerms || ""}
                            placeholder=" "
                            ref={register({ required: true })}
                          /> */}
                          <span>
                            {errors.paymentTerms && "Payment Terms is required"}
                          </span>
                          <div className="valid-feedback">Looks good!</div>
                        </div>
                      </div>
                    </div>

                    <div className="row p-r-15  m-t-10 m-b-10">
                      <div className="col-md-6 mb-12 p-r-0  ">
                        <div className="p-t-5  p-b-5">
                          <input
                            className="form-control hide-border"
                            name="dueDateText"
                            type="text"
                            defaultValue={info.dueDateText || "Due Date"}
                            placeholder="Due Date"
                            ref={register({ required: true })}
                            style={{
                              textAlign: "right",
                              border: "unset",
                              boxShadow: "unset",
                              background: "#fff",
                            }}
                            readOnly
                          />
                          <span>
                            {errors.dueDateText && "Due Date is required"}
                          </span>
                          <div className="valid-feedback">Looks good!</div>
                        </div>
                      </div>
                      <div className="col-md-6 mb-12 p-r-15  ">
                        <div className="p-t-5  p-b-5">
                          <DatePicker
                            key="dueDate"
                            onChange={(date, dateString) =>
                              onChangeDueBill(dateString)
                            }
                            // defaultValue={info.dueDate || ""}
                            format={"MMM DD, YYYY"}
                          />
                          {/* <input
                            className="form-control"
                            name="billDate"
                            type="text"
                            defaultValue={info.billDate}
                            ref={register({ required: true })}
                            hidden
                          /> */}
                          <input
                            className="form-control"
                            name="dueDate"
                            type="text"
                            value={info.dueDate || ""}
                            placeholder=" "
                            ref={register({ required: true })}
                            hidden
                          />
                          <span>
                            {errors.dueDate && "Due Date is required"}
                          </span>
                          <div className="valid-feedback">Looks good!</div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-md-12 mb-12 p-t-5  p-b-5">
                    <div
                      id="invoice-form"
                      style={{
                        background: "#000",
                        marginLeft: 15,
                        borderRadius: 5,
                      }}
                    >
                      <div className="row p-r-15 p-l-0 m-t-10 m-b-10">
                        <div className="col-md-6 mb-12 p-r-0  ">
                          <div style={{ paddingTop: 2, paddingBottom: 2 }}>
                            <input
                              className="form-control"
                              name="itemText"
                              defaultValue={"Item"}
                              type="text"
                              ref={register({ required: true })}
                              style={{
                                // textAlign: "right",
                                borderColor: "#000 !important",
                                boxShadow: "unset",
                                background: "#000",
                                color: "#fff",
                              }}
                              readOnly
                            />
                          </div>
                        </div>
                        <div className="col-md-2 mb-12 p-r-0  ">
                          <div style={{ paddingTop: 2, paddingBottom: 2 }}>
                            <input
                              className="form-control"
                              name="rateText"
                              defaultValue="Unit Price"
                              type="text"
                              // style={{ background: "#000", color: "#fff" }}
                              ref={register({ required: true })}
                              style={{
                                // textAlign: "right",
                                // border: "unset",
                                border: "unset !important",
                                boxShadow: "unset",
                                background: "#000",
                                color: "#fff",
                                textAlign: "center",
                              }}
                              readOnly
                            />
                          </div>
                        </div>

                        <div className="col-md-2 mb-12 p-r-0  ">
                          <div style={{ paddingTop: 2, paddingBottom: 2 }}>
                            <input
                              className="form-control"
                              name="quantityText"
                              defaultValue="Quantity"
                              type="text"
                              // style={{ background: "#000", color: "#fff" }}
                              ref={register({ required: true })}
                              style={{
                                // textAlign: "right",
                                // border: "unset",
                                border: "unset !important",
                                boxShadow: "unset",
                                background: "#000",
                                color: "#fff",
                                textAlign: "center",
                              }}
                              readOnly
                            />
                          </div>
                        </div>
                        <div className="col-md-2 mb-12 p-r-0  ">
                          <div style={{ paddingTop: 2, paddingBottom: 2 }}>
                            <input
                              className="form-control"
                              name="amountText"
                              defaultValue="Amount"
                              type="text"
                              // style={{ background: "#000", color: "#fff" }}
                              ref={register({ required: true })}
                              style={{
                                // textAlign: "right",
                                // border: "unset",
                                border: "unset !important",
                                boxShadow: "unset",
                                background: "#000",
                                color: "#fff",
                                textAlign: "center",
                              }}
                              readOnly
                            />
                          </div>
                        </div>
                      </div>
                    </div>

                    {infoInvoiceItems.map((infoItem, index) => {
                      return (
                        <RowInput
                          {...itemInfoProps}
                          infoItem={infoItem}
                          index={index}
                        />
                      );
                    })}
                    <div className="p-l-15  p-b-15">
                      <button
                        className="btn btn-primary "
                        type="button"
                        onClick={() => addLineItem()}
                        style={{ padding: "5px 10px" }}
                      >
                        <i className="fa fa-plus"></i> Line Item
                      </button>
                    </div>
                  </div>

                  <div className="col-md-7 mb-12 p-t-5  p-b-5">
                    <div className="row">
                      <div className="col-md-4 mb-12 p-r-0  ">
                        <div className="p-t-5  p-b-5">
                          <div className=" p-l-15 p-r-15">
                            <input
                              className="form-control hide-border"
                              name="notesText"
                              type="text"
                              defaultValue={info.notesText || "Notes"}
                              placeholder="Notes"
                              onChange={(e) =>
                                onChangeUrl(null, e.target.value)
                              }
                              ref={register({ required: true })}
                              style={{
                                border: "unset",
                                boxShadow: "unset",
                                background: "#fff",
                              }}
                              readOnly
                            />
                            <span>
                              {errors.notesText && "Notes is required"}
                            </span>
                            <div className="valid-feedback">Looks good!</div>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-12 mb-12 p-r-0  ">
                        <div className="p-t-5  p-b-5">
                          <div className=" p-l-15 p-r-15">
                            <textarea
                              className="form-control"
                              name="notes"
                              type="text"
                              row="6"
                              placeholder="Notes - any relevant information not already covered"
                              ref={register({
                                required: true,
                              })}
                              style={{ height: "64px", resize: "none" }}
                            />
                            <span style={{ color: "#ff5370" }}>
                              {errors.notes && "Notes is required"}
                            </span>
                            <div className="valid-feedback">Looks good!</div>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-4 mb-12 p-r-0  ">
                        <div className="p-t-10  p-b-5">
                          <div className=" p-l-15 p-r-15">
                            <input
                              className="form-control hide-border"
                              name="termsText"
                              type="text"
                              defaultValue={info.termsText || "Terms"}
                              placeholder="Terms"
                              onChange={(e) =>
                                onChangeUrl(null, e.target.value)
                              }
                              ref={register({ required: true })}
                              style={{
                                border: "unset",
                                boxShadow: "unset",
                                background: "#fff",
                              }}
                              readOnly
                            />
                            <span>
                              {errors.termsText && "Terms is required"}
                            </span>
                            <div className="valid-feedback">Looks good!</div>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-12 mb-12 p-r-0  ">
                        <div className="p-t-5  p-b-5">
                          <div className=" p-l-15 p-r-15">
                            <textarea
                              className="form-control"
                              name="terms"
                              type="text"
                              row="6"
                              placeholder="Terms and conditions - late fees, payment methods, delivery schedule"
                              ref={register({
                                required: true,
                              })}
                              style={{ height: "64px", resize: "none" }}
                            />
                            <span style={{ color: "#ff5370" }}>
                              {errors.terms && "Termsis required"}
                            </span>
                            <div className="valid-feedback">Looks good!</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-md-5 mb-12 p-t-5  p-b-5">
                    <div className="row p-r-15 ">
                      <div className="col-md-6 mb-12 p-r-0  ">
                        <div className="p-t-5  p-b-5">
                          <input
                            className="form-control hide-border"
                            name="subtotalText"
                            type="text"
                            defaultValue={info.subtotalText || "Subtotal"}
                            placeholder="Subtotal"
                            ref={register({ required: true })}
                            // style={{
                            //   textAlign: "right",
                            //   border: "unset",
                            // }}
                            style={{
                              textAlign: "right",
                              border: "unset",
                              boxShadow: "unset",
                              background: "#fff",
                            }}
                            readOnly
                          />
                          <span>
                            {errors.subtotalText && "Subtotal is required"}
                          </span>
                          <div className="valid-feedback">Looks good!</div>
                        </div>
                      </div>
                      <div className="col-md-6 mb-12 p-r-15  ">
                        <div className="p-t-5  p-b-5">
                          <input
                            className="form-control"
                            name="subtotal"
                            type="text"
                            value={"QR " + info.subtotal || ""}
                            placeholder=" "
                            readOnly
                            style={{
                              fontWeight: 600,
                              textAlign: "right",
                              border: "unset",
                              boxShadow: "unset",
                              background: "#fff",
                            }}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="row p-r-15   ">
                      <div className="col-md-6 mb-12 p-r-0  ">
                        <div className="p-t-5  p-b-5">
                          <input
                            className="form-control hide-border"
                            name="taxText"
                            type="text"
                            defaultValue={info.taxText || "Vat"}
                            placeholder="Vat"
                            ref={register({ required: true })}
                            style={{
                              textAlign: "right",
                              border: "unset",
                            }}
                            readOnly
                          />
                          <span>{errors.taxText && "Tax is required"}</span>
                          <div className="valid-feedback">Looks good!</div>
                        </div>
                      </div>
                      <div className="col-md-6 mb-12 p-r-15  ">
                        <div className="p-t-5  p-b-5">
                          <div class="input-group  ">
                            <input
                              className="form-control"
                              name="tax"
                              type="number"
                              defaultValue={info.tax || 0}
                              placeholder=" "
                              style={{
                                borderRight: "unset",
                                textAlign: "right",
                              }}
                              onChange={(e) => onChangeTax(e.target.value)}
                            />
                            <div class="input-group-prepend">
                              <span
                                class="input-group-text"
                                id="inputGroupPrepend2"
                                style={{
                                  background: "#ffffff",
                                  borderLeft: "unset",
                                  borderTopRightRadius: 4,
                                  borderBottomRightRadius: 4,
                                }}
                              >
                                %
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row p-r-15  ">
                      <div className="col-md-6 mb-12 p-r-0  ">
                        <div className="p-t-5  p-b-5">
                          <input
                            className="form-control hide-border"
                            name="discountText"
                            type="text"
                            defaultValue={info.discountText || "Discount"}
                            placeholder="Discount"
                            ref={register({ required: true })}
                            style={{
                              textAlign: "right",
                              border: "unset",
                            }}
                            readOnly
                          />
                          <span>
                            {errors.discountText && "Discount is required"}
                          </span>
                          <div className="valid-feedback">Looks good!</div>
                        </div>
                      </div>
                      <div className="col-md-6 mb-12 p-r-15  ">
                        <div className="p-t-5  p-b-5">
                          <div class="input-group  ">
                            <input
                              className="form-control"
                              name="discount"
                              type="number"
                              defaultValue={info.discount || 0}
                              placeholder=" "
                              style={{
                                borderRight: "unset",
                                textAlign: "right",
                              }}
                              onChange={(e) => onChangeDiscount(e.target.value)}
                            />
                            <div class="input-group-prepend">
                              <span
                                class="input-group-text"
                                id="inputGroupPrepend2"
                                style={{
                                  background: "#ffffff",
                                  borderLeft: "unset",
                                  borderTopRightRadius: 4,
                                  borderBottomRightRadius: 4,
                                }}
                              >
                                %
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="row p-r-15   ">
                      <div className="col-md-6 mb-12 p-r-0  ">
                        <div className="p-t-5  p-b-5">
                          <input
                            className="form-control hide-border"
                            name="shippingText"
                            type="text"
                            defaultValue={info.shippingText || "Shipping"}
                            placeholder="Shipping"
                            ref={register({ required: true })}
                            style={{
                              textAlign: "right",
                              border: "unset",
                            }}
                            readOnly
                          />
                          <span>
                            {errors.shippingText && "Shipping is required"}
                          </span>
                          <div className="valid-feedback">Looks good!</div>
                        </div>
                      </div>
                      <div className="col-md-6 mb-12 p-r-15  ">
                        <div className="p-t-5  p-b-5">
                          <div class="input-group  ">
                            <div class="input-group-prepend">
                              <span
                                class="input-group-text"
                                id="inputGroupPrepend2"
                                style={{ background: "#ffffff" }}
                              >
                                QR
                              </span>
                            </div>
                            <input
                              className="form-control"
                              name="shipping"
                              type="number"
                              defaultValue={info.shipping || 0}
                              placeholder=" "
                              style={{
                                borderLeft: "unset",
                                // textAlign: "right",
                              }}
                              onChange={(e) => onChangeShipping(e.target.value)}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row p-r-15   ">
                      <div className="col-md-6 mb-12 p-r-0  ">
                        <div className="p-t-5  p-b-5">
                          <input
                            className="form-control hide-border"
                            name="totalText"
                            type="text"
                            defaultValue={info.totalText || "Total"}
                            placeholder="Total"
                            ref={register({ required: true })}
                            style={{
                              textAlign: "right",
                              border: "unset",
                            }}
                            readOnly
                          />
                          <span>{errors.totalText && "Total is required"}</span>
                          <div className="valid-feedback">Looks good!</div>
                        </div>
                      </div>
                      <div className="col-md-6 mb-12 p-r-15  ">
                        <div className="p-t-5  p-b-5">
                          <input
                            className="form-control"
                            name="total"
                            type="text"
                            value={"QR " + info.total || ""}
                            placeholder=" "
                            readOnly
                            style={{
                              fontWeight: 600,
                              textAlign: "right",
                              border: "unset",
                              boxShadow: "unset",
                              background: "#fff",
                            }}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="row p-r-15   ">
                      <div className="col-md-6 mb-12 p-r-0  ">
                        <div className="p-t-5  p-b-5">
                          <input
                            className="form-control hide-border"
                            name="amountPaidText"
                            type="text"
                            defaultValue={info.amountPaidText || "Amount Paid"}
                            placeholder="Amount Paid"
                            ref={register({ required: true })}
                            style={{
                              textAlign: "right",
                              border: "unset",
                            }}
                            readOnly
                          />
                          <span>
                            {errors.amountPaidText && "Amount Paid is required"}
                          </span>
                          <div className="valid-feedback">Looks good!</div>
                        </div>
                      </div>
                      <div className="col-md-6 mb-12 p-r-15  ">
                        <div className="p-t-5  p-b-5">
                          <div class="input-group  ">
                            <div class="input-group-prepend">
                              <span
                                class="input-group-text"
                                id="inputGroupPrepend2"
                                style={{ background: "#ffffff" }}
                              >
                                QR
                              </span>
                            </div>
                            <input
                              className="form-control"
                              name="amountPaid"
                              type="number"
                              defaultValue={info.amountPaid || 0}
                              placeholder=" "
                              style={{
                                borderLeft: "unset",
                                // textAlign: "right",
                              }}
                              onChange={(e) =>
                                onChangeAmountPaid(e.target.value)
                              }
                              ref={register({ required: true })}
                            />
                            <span>
                              {errors.amountPaid && "Amount Paid is required"}
                            </span>
                            <div className="valid-feedback">Looks good!</div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row p-r-15   ">
                      <div className="col-md-6 mb-12 p-r-0  ">
                        <div className="p-t-5  p-b-5">
                          <input
                            className="form-control hide-border"
                            name="balanceDueText"
                            type="text"
                            defaultValue={info.balanceDueText || "Balance Due"}
                            placeholder="Balance Due"
                            ref={register({ required: true })}
                            style={{
                              textAlign: "right",
                              border: "unset",
                            }}
                            readOnly
                          />
                          <span>
                            {errors.balanceDueText && "Balance due is required"}
                          </span>
                          <div className="valid-feedback">Looks good!</div>
                        </div>
                      </div>
                      <div className="col-md-6 mb-12 p-r-15  ">
                        <div className="p-t-5  p-b-5">
                          <input
                            className="form-control"
                            name="balanceDue"
                            type="text"
                            value={"QR " + info.balanceDue || 0}
                            placeholder=" "
                            readOnly
                            style={{
                              fontWeight: 600,
                              textAlign: "right",
                              border: "unset",
                              boxShadow: "unset",
                              background: "#fff",
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="p-15 float-right">
                  <button className="btn btn-primary " type="submit">
                    {isEdit ? "Update" : "Submit"}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};
export default connect()(ProductForm);
